import { useEffect, useRef } from 'react';

/** Keep CSS timelines paused when the scene is clipped out of view or the tab is hidden. */
export default function useSceneActivity() {
  const ref = useRef(null);
  useEffect(() => {
    const scene = ref.current;
    if (!scene) return undefined;
    let visible = false;
    const update = () => {
      scene.dataset.sceneActive = visible && !document.hidden ? 'true' : 'false';
    };
    const observer = new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      update();
    }, { threshold: 0 });
    observer.observe(scene);
    document.addEventListener('visibilitychange', update);
    return () => {
      observer.disconnect();
      document.removeEventListener('visibilitychange', update);
    };
  }, []);
  return ref;
}
